import {
  fetchBuilderDetailSuccess,
  fetchBuilderEntriesSuccess,
  fetchBuilderSummarySuccess,
  fetchBuilderSucess,
  deleteBuilderSuccess,
  fetchStaffEntriesSuccess,
  fetchAgreementLogsSuccess,
  postAgreementLogsSuccess,
  fetchAgreementLogsDetailSuccess,
  putAgreementLogsSuccess,
  deleteAgreementLogsSuccess,
  fetchBuilderFeatureFlagSuccess,
  putBuilderFeatureFlagSuccess
} from "../action/action";
import {
  finishLoading,
  dispatchError,
  enableLoading
} from "common/Stores/service/service";
import { api } from "common/api/api";
import { putBuilderSuccess } from "components/shops/shopDetail/action/action";

export const fetchBuilderDetail = builderId => {
  const url = `/builders/${builderId}`;
  return dispatch => {
    dispatch(enableLoading());
    api
      .get(url)
      .then(res => {
        dispatch(fetchBuilderDetailSuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const fetchBuilderEntries = () => {
  const url = '/builders/names';
  return dispatch => {
    dispatch(enableLoading());
    api
      .get(url)
      .then(res => {
        dispatch(fetchBuilderEntriesSuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const fetchBuilderSummary = builderId => {
  const url = `/builders/${builderId}/name`;
  return dispatch => {
    dispatch(enableLoading());
    api
      .get(url)
      .then(res => {
        dispatch(fetchBuilderSummarySuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const fetchBuilder = builderId => {
  const url = `/builders/${builderId}`;
  return dispatch => {
    dispatch(enableLoading());
    api
      .get(url)
      .then(res => {
        dispatch(fetchBuilderSucess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const putBuilder = (builderId, data, handleError) => {
  const url = `/builders/${builderId}`;
  return dispatch => {
    dispatch(enableLoading());
    api
      .put(url, data)
      .then(res => {
        dispatch(putBuilderSuccess());
        dispatch(fetchBuilderSummary(builderId));
        dispatch(fetchBuilderDetail(builderId));
        dispatch(finishLoading());
      })
      .catch(err => {
        if(handleError && err.response.status === 500) {
          handleError();
        } else {
          dispatch(dispatchError(err));
        }
      });
  };
};

export const deleteBuilder = (uniqueCode, handleError) => {
  return dispatch => {
    dispatch(enableLoading());
    api
      .delete(`/logbuild/builders/${uniqueCode}`)
      .then(res => {
        dispatch(deleteBuilderSuccess());
        dispatch(finishLoading());
      })
      .catch(err => {
        if(handleError && err.response.status === 500) {
          handleError();
        } else {
          dispatch(dispatchError(err));
        }
      });
  };
};

export const fetchStaffEntries = () => {
  const url = '/lb-users/names';
  return dispatch => {
    api.get(url).then(res => {
      dispatch(fetchStaffEntriesSuccess(res.data));
    });
  };
};

export const fetchAgreementLogs = builderUC => {
  return dispatch => {
    dispatch(enableLoading());
    api
      .get(`/logbuild/builder-agreement-logs?buildersUC=${builderUC}`)
      .then(res => {
        dispatch(fetchAgreementLogsSuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const fetchAgreementDetail = params => {
  return dispatch => {
    dispatch(enableLoading());
    api
      .get(`/logbuild/builder-agreement-logs/${params}`)
      .then(res => {
        dispatch(fetchAgreementLogsDetailSuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const postAgreementLogs = agreement => {
  return dispatch => {
    dispatch(enableLoading());
    api
      .post(`/logbuild/builder-agreement-logs`, agreement)
      .then(res => {
        dispatch(postAgreementLogsSuccess(res.data));
        dispatch(fetchAgreementLogs(agreement.buildersUC));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const putAgreementDetail = (params, agreement) => {
  return dispatch => {
    dispatch(enableLoading());
    api
      .put(`/logbuild/builder-agreement-logs/${params}`, agreement)
      .then(res => {
        dispatch(putAgreementLogsSuccess(res.data));
        dispatch(fetchAgreementLogs(agreement.buildersUC));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const deleteAgreement = params => {
  return dispatch => {
    dispatch(enableLoading());
    api
      .delete(`/logbuild/builder-agreement-logs/${params}`)
      .then(res => {
        dispatch(deleteAgreementLogsSuccess(res.data));
        dispatch(fetchAgreementLogs(params.split(".")[0]));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const fetchBuilderFeatureFlag = builderId => {
  const url = `/builders/${builderId}/features`;
  return dispatch => {
    dispatch(enableLoading());
    api
      .get(url)
      .then(res => {
        dispatch(fetchBuilderFeatureFlagSuccess(res.data));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const putBuilderFeatureFlag = (builderId, featureId, val) => {
  const url = `/builders/${builderId}/features/${featureId}`;
  return dispatch => {
    dispatch(enableLoading());
    api
      .patch(url, val)
      .then(res => {
        dispatch(putBuilderFeatureFlagSuccess(res.data));
        dispatch(fetchBuilderFeatureFlag(builderId));
        dispatch(finishLoading());
      })
      .catch(err => {
        dispatch(dispatchError(err));
      });
  };
};

export const createBuilderUser = async (builderId, val) => {
  const url = `/builders/${builderId}/users`;
  enableLoading();
  const res = await api.post(url, val);
  finishLoading();
  if (res.status !== 200) {
    dispatchError(res)
  }
  const { data } = res;
  return data;
};


export const createBuilderBlobContainer = async (builderId) => {
  const url = `/builders/${builderId}/blob-container`;
  enableLoading();
  const res = await api.post(url, {});
  finishLoading();
  if (res.status !== 200) {
    dispatchError(res)
  }
  const { data } = res;
  return data;
};


export const createBuilderVonage = async (builderId) => {
  const url = `/builders/${builderId}/vonage`;
  enableLoading();
  const res = await api.post(url, {});
  finishLoading();
  if (res.status !== 200) {
    dispatchError(res)
  }
  const { data } = res;
  return data;
};

export const fetchBuilderCreationStatus = async (builderId) => {
  const url = `/builders/${builderId}/creation-status`;
  enableLoading();
  const res = await api.get(url);
  console.log(res);
  finishLoading();
  if (res.status !== 200) {
    dispatchError(res)
  }
  const { data } = res;
  return data;
};


export const fetchBuilderUserJobConf = async () => {
  const url = '/users/builder-user-job-conf';
  enableLoading();
  const res = await api.get(url);
  finishLoading();
  if (res.status !== 200) {
    dispatchError(res)
  }
  const { data } = res;
  return data;
};
